module.exports = __webpack_public_path__ + "static/media/icn-download.7e9b8340.svg";